
export class PatientSearchResultDto {
    startIndex: number;
    endIndex: number;
    totalCount: number;
    data: Array<PatientDto>
}
export class PatientDto {
    
    id: string;
    addressId: string;
    title: string;
    firstName: string;
    middleName: string;
    lastName: string;
    nhsNumber: string;
    dob: Date;
    sex: string;
    addressLine: string;
    postCode: string;
}

export class BagDto {
    patientId: string;
    title: string;
    firstName: string;
    middleName: string;
    lastName: string;
    dob: Date;
    nhsNumber: string;
    addressLine: string;
    postCode: string;
    whenCreated: Date;
    whenUpdated: Date;
    bagStatus: number;
    bagFMDStatus: number;
    isRemoved: boolean;
    numberOfMeds: number;
    numberOfFMDSuccessMeds: number;
    numberOfFMDFailedMeds: number;
    numberOfFMDPendingMeds: number;
    numberOfFMDNAMeds: number;
    id: string;
    whoUpdatedUserId: string;


    patientBagMeds: Array<BagItemDto>
}

export class BagItemDto {
    bagId: string;
    id: string;
    isRemoved: boolean;
    status: number;

    //FMD Scan Details
    batchNumber : string;
    sn: string;
    expiryDate: string;
    gtin: string;

    //Fmd Feedback
    fmdError: string;
    packReason: string;
    packState: string;
    returnCode: string;
    returnCodeDesc: string;
    interMarket: boolean;

    //Drug Details
    vpid: string;
    apid: string;
    drugName: string;
}

export class BagListDto {
    data: Array<BagDto>
}
export class BagSearchDto {
    bagList: BagListDto
} 


export class FmdCode {
    batchNumber: string;
    sn: string;
    expiryDate: string;
    gtin: string;
}


// WEBPACK FOOTER //
// ./ClientApp/dto/Fmd/Models.ts